export default "__VITE_ASSET__BMfVoNNJ__"